import { render, staticRenderFns } from "./BtnSelect.vue?vue&type=template&id=0548f805&"
import script from "./BtnSelect.vue?vue&type=script&lang=js&"
export * from "./BtnSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BtnSelect.vue"
export default component.exports